exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code_btn[data-v-2cc400cc]{width:130px;margin-left:20px;color:#ffffff;border-radius:3px;background-color:#2993ff}\n", ""]);

// exports
